import UrlService from './services/url-service';
angular.module('eatself').factory('UrlService', () => UrlService);

import ShopService from './services/shop-service';
angular.module('eatself').factory('ShopService', () => ShopService);

import DataStore from './services/data-store';
angular.module('eatself').factory('dataStore', () => DataStore);

import UserService from './services/user-service';
angular.module('eatself').factory('principal', () =>UserService);

import CheckoutService from './checkout/CheckoutService';
angular.module('eatself').factory('CheckoutService', () => CheckoutService);

import PaymentService from './checkout/payment-service';
angular.module('eatself').factory('PaymentService', () => PaymentService);

import component15 from './layout/app-footer.vue';
angular.module('eatself').value('appFooter', component15);
angular.module('eatself').directive('appFooter', function (createVueComponent) {
	return createVueComponent('appFooter')
})

import * as constants from './services/constants';
let mod = angular.module('eatself');
for(let i in constants) {
	mod.constant(i, constants[i]);
}

import CartService from './services/cart-service';
angular.module('eatself').factory('CartService', function () {
	return CartService;
});

import component16 from './components/navbar1.vue';
angular.module('eatself').value('navbar1', component16);
angular.module('eatself').directive('navbar1', function (createVueComponent) {
	return createVueComponent('navbar1')
})

import UiService from './services/ui-service';
angular.module('eatself').factory('UiService', function() {
	return UiService;
});

import BackupService from './services/backup-service';
angular.module('eatself').factory('BackupService', function() {
	return BackupService;
});

import TreeOps from './services/tree-ops';
angular.module('eatself').factory('TreeOps', function() {
	return TreeOps;
});

import ModalTemplate from './components/modal-template.vue';
angular.module('eatself').value('modalTemplate', ModalTemplate);
angular.module('eatself').directive('modalTemplate', function (createVueComponent) {
	return createVueComponent('modalTemplate');
});

import ProductOptions from './components/product-options.vue';
angular.module('eatself').value('productOptions', ProductOptions);
angular.module('eatself').directive('productOptions', function (createVueComponent) {
	return createVueComponent('productOptions')
})

import proposeChoice from './components/propose-choice.vue';
angular.module('eatself').value('proposeChoice', proposeChoice);
angular.module('eatself').directive('proposeChoice', function (createVueComponent) {
	return createVueComponent('proposeChoice')
})

import OptionCategoryService from './services/option-category-service';
angular.module('eatself').factory('OptionCategoryService', function() {
	return OptionCategoryService;
});

import ThemeService from './services/theme-service';
angular.module('eatself')
.run(['ThemeService',function(ts) {}])
.factory('ThemeService',function() { return ThemeService });

import homeBottom from './home/home-bottom.vue';
angular.module('eatself').value('homeBottom', homeBottom);
angular.module('eatself').directive('homeBottom', function (createVueComponent) {
	return createVueComponent('homeBottom')
})

import deliverooScraping from './admin-components/deliveroo-scraping.vue';
angular.module('eatself').value('deliverooScraping', deliverooScraping);
angular.module('eatself').directive('deliverooScraping', function (createVueComponent) {
	return createVueComponent('deliverooScraping')
})

import clientPassword from './client/client-password.vue';
angular.module('eatself').value('clientPassword', clientPassword);
angular.module('eatself').directive('clientPassword', function (createVueComponent) {
	return createVueComponent('clientPassword')
})

import editConfirmMethods from './admin-components/edit-confirm-methods.vue';
angular.module('eatself').value('editConfirmMethods', editConfirmMethods);
angular.module('eatself').directive('editConfirmMethods', function (createVueComponent) {
	return createVueComponent('editConfirmMethods')
})

import deliverectStatus from './orders/deliverect-status.vue';
angular.module('eatself').value('deliverectStatus', deliverectStatus);
angular.module('eatself').directive('deliverectStatus', function (createVueComponent) {
	return createVueComponent('deliverectStatus')
})

import cart from './components/cart/cart.vue';
angular.module('eatself').value('cart', cart);
angular.module('eatself').directive('cart', function (createVueComponent) {
	return createVueComponent('cart')
});

import orderItems from './components/order-items.vue';
angular.module('eatself').value('orderItems', orderItems);
angular.module('eatself').directive('orderItems', function (createVueComponent) {
	return createVueComponent('orderItems')
});

import checkoutSalon from './components/CheckoutSalon.vue';
angular.module('eatself').value('checkoutSalon', checkoutSalon);
angular.module('eatself').directive('checkoutSalon', function (createVueComponent) {
	return createVueComponent('checkoutSalon')
});

import checkoutSuggestions from './checkout/CheckoutSuggestions.vue';
angular.module('eatself').value('checkoutSuggestions', checkoutSuggestions);
angular.module('eatself').directive('checkoutSuggestions', function (createVueComponent) {
	return createVueComponent('checkoutSuggestions')
});

import tagEditor from './admin-components/tag-editor.vue';
angular.module('eatself').value('tagEditor', tagEditor);
angular.module('eatself').directive('tagEditor', function (createVueComponent) {
	return createVueComponent('tagEditor')
})

import productTags from './components/product-tags.vue';
angular.module('eatself').value('productTags', productTags);
angular.module('eatself').directive('productTags', function (createVueComponent) {
	return createVueComponent('productTags')
})

import navbar from './layout/navbar.vue';
angular.module('eatself').value('navbar', navbar);
angular.module('eatself').directive('navbar', function (createVueComponent) {
	return createVueComponent('navbar')
});

import sidebar from './layout/sidebar.vue';
angular.module('eatself').value('sidebar', sidebar);
angular.module('eatself').directive('sidebar', function (createVueComponent) {
	return createVueComponent('sidebar')
});

import modalCmsNavigation from './layout/modal-cms-navigation.vue';
angular.module('eatself').value('modalCmsNavigation', modalCmsNavigation);
angular.module('eatself').directive('modalCmsNavigation', function (createVueComponent) {
	return createVueComponent('modalCmsNavigation')
});

import modalUserNavigation from './layout/modal-user-navigation.vue';
angular.module('eatself').value('modalUserNavigation', modalUserNavigation);
angular.module('eatself').directive('modalUserNavigation', function (createVueComponent) {
	return createVueComponent('modalUserNavigation')
});

import checkoutDiscount from './checkout/checkout-discount.vue';
angular.module('eatself').value('checkoutDiscount', checkoutDiscount);
angular.module('eatself').directive('checkoutDiscount', function (createVueComponent) {
	return createVueComponent('checkoutDiscount')
})

import eatselfCarte from './components/eatself-carte.vue';
angular.module('eatself').value('eatselfCarte', eatselfCarte);
angular.module('eatself').directive('eatselfCarte', function (createVueComponent) {
	return createVueComponent('eatselfCarte')
})

import profileFideliteCard from './components/profile-fidelite-card.vue';
angular.module('eatself').value('profileFideliteCard', profileFideliteCard);
angular.module('eatself').directive('profileFideliteCard', function (createVueComponent) {
	return createVueComponent('profileFideliteCard')
})

import signupAfterConfirm from './checkout/SignupAfterConfirm.vue';
angular.module('eatself').value('signupAfterConfirm', signupAfterConfirm);
angular.module('eatself').directive('signupAfterConfirm', function (createVueComponent) {
	return createVueComponent('signupAfterConfirm')
})

import orderConfirmed from './checkout/order-confirmed.vue';
angular.module('eatself').value('orderConfirmed', orderConfirmed);
angular.module('eatself').directive('orderConfirmed', function (createVueComponent) {
	return createVueComponent('orderConfirmed')
})

import orderDetails from './orders/order-details.vue';
angular.module('eatself').value('orderDetails', orderDetails);
angular.module('eatself').directive('orderDetails', function (createVueComponent) {
	return createVueComponent('orderDetails')
})

import adminOrderDetails from './admin-components/admin-order-details.vue';
angular.module('eatself').value('adminOrderDetails', adminOrderDetails);
angular.module('eatself').directive('adminOrderDetails', function (createVueComponent) {
	return createVueComponent('adminOrderDetails')
})

import cgv from './components/cgv.vue';
angular.module('eatself').value('cgv', cgv);
angular.module('eatself').directive('cgv', function (createVueComponent) {
	return createVueComponent('cgv')
});

import checkoutComoPoints from './checkout/checkout-como-points.vue';
angular.module('eatself').value('checkoutComoPoints', checkoutComoPoints);
angular.module('eatself').directive('checkoutComoPoints', function (createVueComponent) {
	return createVueComponent('checkoutComoPoints')
});

import home from './home/home.vue';
angular.module('eatself').value('home', home);
angular.module('eatself').directive('home', function (createVueComponent) {
	return createVueComponent('home')
});

import dsp2 from './checkout/Dsp2.vue';
angular.module('eatself').value('dsp2', dsp2);
angular.module('eatself').directive('dsp2', function (createVueComponent) {
	return createVueComponent('dsp2');
});

import pagePerso from './components/page-perso.vue';
angular.module('eatself').value('pagePerso', pagePerso);
angular.module('eatself').directive('pagePerso', function (createVueComponent) {
	return createVueComponent('pagePerso');
});

import orderState from './components/order-state.vue';
angular.module('eatself').value('orderState', orderState);
angular.module('eatself').directive('orderState', function (createVueComponent) {
	return createVueComponent('orderState')
});

import refundButton from './components/refund-button.vue';
angular.module('eatself').value('refundButton', refundButton);
angular.module('eatself').directive('refundButton', function (createVueComponent) {
	return createVueComponent('refundButton')
});

import carnetCovid19 from './components/carnet-covid19.vue';
angular.module('eatself').value('carnetCovid19', carnetCovid19);
angular.module('eatself').directive('carnetCovid19', function (createVueComponent) {
	return createVueComponent('carnetCovid19')
});

import rappelDone from './components/rappel-done.vue';
angular.module('eatself').value('rappelDone', rappelDone);
angular.module('eatself').directive('rappelDone', function (createVueComponent) {
	return createVueComponent('rappelDone')
});

import recrutement from './fidelity/recrutement.vue';
angular.module('eatself').value('recrutement', recrutement);
angular.module('eatself').directive('recrutement', function (createVueComponent) {
	return createVueComponent('recrutement')
});


import fidelityInscription from './fidelity/fidelity-inscription.vue';
angular.module('eatself').value('fidelityInscription', fidelityInscription);
angular.module('eatself').directive('fidelityInscription', function (createVueComponent) {
	return createVueComponent('fidelityInscription')
});


import updateFideliteCard from './fidelity/update-fidelite-card.vue';
angular.module('eatself').value('updateFideliteCard', updateFideliteCard);
angular.module('eatself').directive('updateFideliteCard', function (createVueComponent) {
	return createVueComponent('updateFideliteCard')
});


import fideliteCardLink from './fidelity/fidelite-card-link.vue';
angular.module('eatself').value('fideliteCardLink', fideliteCardLink);
angular.module('eatself').directive('fideliteCardLink', function (createVueComponent) {
	return createVueComponent('fideliteCardLink')
});

import clientDetails from './client/client-details.vue';
angular.module('eatself').value('clientDetails', clientDetails);
angular.module('eatself').directive('clientDetails', function (createVueComponent) {
	return createVueComponent('clientDetails')
});

import orderPage from './orders/order-page.vue';
angular.module('eatself').value('orderPage', orderPage);
angular.module('eatself').directive('orderPage', function (createVueComponent) {
	return createVueComponent('orderPage')
});

import ordersSplitListView from './orders/orders-split-list-view.vue';
angular.module('eatself').value('ordersSplitListView', ordersSplitListView);
angular.module('eatself').directive('ordersSplitListView', function (createVueComponent) {
	return createVueComponent('ordersSplitListView')
});

import ordersFilter from './orders/orders-filter.vue';
angular.module('eatself').value('ordersFilter', ordersFilter);
angular.module('eatself').directive('ordersFilter', function (createVueComponent) {
	return createVueComponent('ordersFilter')
});

import mobileFooter from './layout/mobile-footer.vue';
angular.module('eatself').value('mobileFooter', mobileFooter);
angular.module('eatself').directive('mobileFooter', function (createVueComponent) {
	return createVueComponent('mobileFooter')
});

import sitemap from './templates/sitemap.vue';
angular.module('eatself').value('sitemap', sitemap);
angular.module('eatself').directive('sitemap', function (createVueComponent) {
	return createVueComponent('sitemap')
});

import cardBrand from './components/card-brand.vue';
angular.module('eatself').value('cardBrand', cardBrand);
angular.module('eatself').directive('cardBrand', function (createVueComponent) {
	return createVueComponent('cardBrand')
});

import rgpd from './components/rgpd.vue';
angular.module('eatself').value('rgpd', rgpd);
angular.module('eatself').directive('rgpd', function (createVueComponent) {
	return createVueComponent('rgpd')
});

import productModal from './components/product-modal.vue';
angular.module('eatself').value('productModal', productModal);
angular.module('eatself').directive('productModal', function (createVueComponent) {
	return createVueComponent('productModal');
});

import Switch from './components/switch.vue';
angular.module('eatself').value('switch', Switch);
angular.module('eatself').directive('switch', function (createVueComponent) {
	return createVueComponent('switch')
});

import promoListView from './components/promo-list-view.vue'
angular.module('eatself').value('promoListView', promoListView);
angular.module('eatself').directive('promoListView', function (createVueComponent) {
	return createVueComponent('promoListView')
});

import mapRestos from './eatself-directory/map-restos.vue'
angular.module('eatself').value('mapRestos', mapRestos);
angular.module('eatself').directive('mapRestos', function (createVueComponent) {
	return createVueComponent('mapRestos')
});

import installBanner from './layout/install-banner.vue'
angular.module('eatself').value('installBanner', installBanner);
angular.module('eatself').directive('installBanner', function (createVueComponent) {
	return createVueComponent('installBanner')
});

import editAddress from './checkout/EditAddress.vue'
angular.module('eatself').value('editAddress', editAddress);
angular.module('eatself').directive('editAddress', function (createVueComponent) {
	return createVueComponent('editAddress')
});

import checkoutAddress from './checkout/CheckoutAddress.vue'
angular.module('eatself').value('checkoutAddress', checkoutAddress);
angular.module('eatself').directive('checkoutAddress', function (createVueComponent) {
	return createVueComponent('checkoutAddress')
});

import googleMap from './components/google-map.vue'
angular.module('eatself').value('googleMap', googleMap);
angular.module('eatself').directive('googleMap', function (createVueComponent) {
	return createVueComponent('googleMap')
});

import checkoutClientLogin from './checkout/checkout-client-login.vue'
angular.module('eatself').value('checkoutClientLogin', checkoutClientLogin);
angular.module('eatself').directive('checkoutClientLogin', function (createVueComponent) {
	return createVueComponent('checkoutClientLogin')
});

import checkoutHome from './checkout/CheckoutHome.vue'
angular.module('eatself').value('checkoutHome', checkoutHome);
angular.module('eatself').directive('checkoutHome', function (createVueComponent) {
	return createVueComponent('checkoutHome')
});

import deliveryMode from './checkout/DeliveryMode.vue'
angular.module('eatself').value('deliveryMode', deliveryMode);
angular.module('eatself').directive('deliveryMode', function (createVueComponent) {
	return createVueComponent('deliveryMode')
});

import proabono from './admin-components/proabono.vue';
angular.module('eatself').value('proabono', proabono);
angular.module('eatself').directive('proabono', function (createVueComponent) {
	return createVueComponent('proabono')
});

import orderSummary from './ticket/order-summary.vue'
angular.module('eatself').value('orderSummary', orderSummary);
angular.module('eatself').directive('orderSummary', function (createVueComponent) {
	return createVueComponent('orderSummary')
});

import ticketIntro from './ticket/ticket-intro.vue'
angular.module('eatself').value('ticketIntro', ticketIntro);
angular.module('eatself').directive('ticketIntro', function (createVueComponent) {
	return createVueComponent('ticketIntro')
});

import ticketSuccess from './ticket/ticket-success.vue'
angular.module('eatself').value('ticketSuccess', ticketSuccess);
angular.module('eatself').directive('ticketSuccess', function (createVueComponent) {
	return createVueComponent('ticketSuccess')
});

import adminTicketList from './ticket/admin-ticket-list.vue'
angular.module('eatself').value('adminTicketList', adminTicketList);
angular.module('eatself').directive('adminTicketList', function (createVueComponent) {
	return createVueComponent('adminTicketList')
});

import stuartStatus from './components/stuart-status.vue'
angular.module('eatself').value('stuartStatus', stuartStatus);
angular.module('eatself').directive('stuartStatus', function (createVueComponent) {
	return createVueComponent('stuartStatus')
});

import deliveryDate from './checkout/DeliveryDate.vue'
angular.module('eatself').value('deliveryDate', deliveryDate);
angular.module('eatself').directive('deliveryDate', function (createVueComponent) {
	return createVueComponent('deliveryDate')
});

import payGreenLink from './checkout/pay-green-link.vue'
angular.module('eatself').value('payGreenLink', payGreenLink);
angular.module('eatself').directive('payGreenLink', function (createVueComponent) {
	return createVueComponent('payGreenLink')
});

import checkoutPayment from './checkout/CheckoutPayment.vue'
angular.module('eatself').value('checkoutPayment', checkoutPayment);
angular.module('eatself').directive('checkoutPayment', function (createVueComponent) {
	return createVueComponent('checkoutPayment')
});

import total from './components/total.vue'
angular.module('eatself').value('total', total);
angular.module('eatself').directive('total', function (createVueComponent) {
	return createVueComponent('total')
});


import checkoutTicket from './ticket/checkout-ticket.vue'
angular.module('eatself').value('checkoutTicket', checkoutTicket);
angular.module('eatself').directive('checkoutTicket', function (createVueComponent) {
    return createVueComponent('checkoutTicket')
});

import stageChooseShop from './checkout/StageChooseShop.vue'
angular.module('eatself').value('stageChooseShop', stageChooseShop);
angular.module('eatself').directive('stageChooseShop', function (createVueComponent) {
    return createVueComponent('stageChooseShop')
});

import infoEditor from './admin-components/info-editor.vue';
angular.module('eatself').value('infoEditor', infoEditor);
angular.module('eatself').directive('infoEditor', function (createVueComponent) {
	return createVueComponent('infoEditor')
});

import chooseConfirmMethod from './checkout/ChooseConfirmMethod.vue';
angular.module('eatself').value('chooseConfirmMethod', chooseConfirmMethod);
angular.module('eatself').directive('chooseConfirmMethod', function (createVueComponent) {
	return createVueComponent('chooseConfirmMethod')
});

import payGreen from './checkout/PayGreen.vue';
angular.module('eatself').value('payGreen', payGreen);
angular.module('eatself').directive('payGreen', function (createVueComponent) {
	return createVueComponent('payGreen')
});

import edenred from './checkout/Edenred.vue';
angular.module('eatself').value('edenred', edenred);
angular.module('eatself').directive('edenred', function (createVueComponent) {
	return createVueComponent('edenred')
});

import eatselfPagination from './components/EatselfPagination.vue';
angular.module('eatself').value('eatselfPagination', eatselfPagination);
angular.module('eatself').directive('eatselfPagination', function (createVueComponent) {
	return createVueComponent('eatselfPagination')
});

import eatselfPopover from './components/confirm-popover.vue';
angular.module('eatself').value('eatselfPopover', eatselfPopover);
angular.module('eatself').directive('eatselfPopover', function (createVueComponent) {
	return createVueComponent('eatselfPopover')
});

import marketing from './admin-components/marketing.vue';
angular.module('eatself').value('marketing', marketing);
angular.module('eatself').directive('marketing', function (createVueComponent) {
	return createVueComponent('marketing')
});

import addressTest from './admin-components/AddressTest.vue';
angular.module('eatself').value('addressTest', addressTest);
angular.module('eatself').directive('addressTest', function (createVueComponent) {
	return createVueComponent('addressTest')
});

import paymentName from './components/payment-name.vue';
angular.module('eatself').value('paymentName', paymentName);
angular.module('eatself').directive('paymentName', function (createVueComponent) {
	return createVueComponent('paymentName')
});

import saleAreaName from './components/sale-area-name.vue';
angular.module('eatself').value('saleAreaName', saleAreaName);
angular.module('eatself').directive('saleAreaName', function (createVueComponent) {
	return createVueComponent('saleAreaName')
});

import treePath from './components/tree-path.vue';
angular.module('eatself').value('treePath', treePath);
angular.module('eatself').directive('treePath', function (createVueComponent) {
	return createVueComponent('treePath')
});